import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import MessagingContainer from 'src/ui/features/Messaging/containers/MessagingContainer';
import { updateBodyClass } from 'src/helpers';
import { MESSAGING_URL, BODY_CLASSES } from 'src/constants/constants';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { newDashboardRoutes } from 'src/newDashboardRoutes';

class MessagingRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.MESSAGING);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.MESSAGING);
  }

  render() {
    return (
      <Layout headerName={intl.get('messaging.pageTitle')}>
        <Switch>
          <Route path={MESSAGING_URL + '/inbox/:messageId'} render={props => <MessagingContainer {...props} />} />
          <Route path={MESSAGING_URL + '/compose'} render={props => <MessagingContainer showCompose={true} {...props} />} />
          <Route path={MESSAGING_URL} render={props => <MessagingContainer {...props} />} />
        </Switch>
        {newDashboardRoutes}
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MessagingRoot);
